module.exports = __webpack_public_path__ + "img/logo_large.f6cbabae.png";